import axios from "axios"
import {getStationCode} from "../../network/NetworkUtil";
import {
    getAPIGatewayDataFromParent,
    getUserLoginFromParent,
    getTcpRolesFromParent
} from "../../handler/ParentDataHandler";
import {
    calculatePickDurationWithMultipleAssociates,
    calculatePickDurationWithSingleAssociate,
    convertEpochMillisToLocalTime,
    convertSecondsToHHMM,
    convertSecondsToTimeFormat,
    formatAlias,
    getCluster,
    getDateInMMDDYYYYWithOffset,
    isARorSSD,
    isDynamicRoute, isRSWSBosonFlowEnabled,
    sortList,
    sortObjectsBySequenceNumber
} from "../../util/Util";
import {
    AR_V2,
    CONTAINER_TYPE,
    CORE_AMZL,
    DEFAULT_CAPABILITIES,
    NOT_IN_CART,
    NOT_IN_CART_ELIGIBLE_STATUSES,
    PACKAGE_STATUS,
    SORT_DIRECTION,
    TIMEOUTS
} from "../../util/Constants";
import {
    ASSIGNABLE,
    DEPARTED,
    getCartStatusARv2, getNextWorkGroups, getPicklistProgress,
    getPickStatus,
    getPickStatusForPicklist,
    getRouteStatus,
    handleUnassignedRoutes,
    IN_PROGRESS,
    MISSING, NOT_ASSIGNED,
    NOT_READY,
    PICK_VISIBILITY_DROP_TO_CART_STATUS,
    READY,
    SIDELINED,
    STAGED
} from "../../util/EntityStatusManager";
import {clearCache} from "../../util/CacheManager";
import {ROUTE_DATA_CACHE_KEY} from "../../util/LocalStorageKeys";
import {
    ERROR_COUNT_METRIC,
    GLOBAL_METRIC_KEY,
    IVS_GET_PACKAGE_METRIC,
    logErrorMetric,
    logOperationalMetric,
    MetricType,
    PICK_TAB_METRIC_KEY,
    ROUTE_INFO_METRIC_KEY,
    RSWS_CUT_ROUTE_METRIC,
    RSWS_FORCE_ASSIGN_ROUTE_METRIC,
    RSWS_GET_PACKAGE_METRIC, RSWS_GET_PICK_STATUS_IN_GRID,
    RSWS_PRIORITIZE_ROUTE_METRIC,
    RSWS_ROUTE_DETAIL_METRIC,
    RSWS_ROUTE_LIST_METRIC,
    RSWS_SIDELINE_ROUTE_METRIC,
    RSWS_STATION_CONFIG_METRIC,
    RSWS_STATION_DETAILS_METRIC,
    RSWS_UNASSIGN_ROUTE_METRIC,
    SVS_FLOOR_DATA_METRIC,
    SVS_PACKAGE_HIERARCHY_METRIC
} from "../../util/MetricUtil";
import {
    extractStageListId,
    getCartStagingLocation, getDisplayLabel,
    getRouteStagingLocation,
    transformStagingLocations
} from "../../util/DataTransformUtil";
import {Logger} from "../../util/Logger";

/** Fetch Route List **/
export function fetchRouteInformation(dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig, configDispatch) {
    getRouteInformation(dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig, configDispatch)
}

/** fetch sideline metrics if ARv2 **/
export function fetchPickMetrics(dispatcher, baseUrl, capability, stationConfig) {
    if (capability === AR_V2) {
        getSidelinePackageCount(dispatcher, baseUrl, stationConfig);
        getInductedPackageCount(dispatcher);
    }
}

async function getuserDetails() {
    const response = await  getUserLoginFromParent();
    return response.name;
}

async function getSidelinePackageCount(dispatcher, baseUrl, stationConfig) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const requestBody = {
            "stationCode": stationCode,
            "metricList": ["SIDELINED"],
            "date": getDateInMMDDYYYYWithOffset(0),
            "groupBy": "NODE",
            "filters": {
                "cycle": ["CYCLE_1"]    //TODO
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/package/metric",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/package/metric", requestBody);
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_PACKAGE_METRIC, MetricType.SUCCESS);
            dispatcher({ type: "RECEIVE_SIDELINE_COUNT", data: { sidelinedPackages: extractSidelinedPackageCount(response.data) } });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in PickNetworkAPI.getSidelinePackageCount" , error);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_PACKAGE_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getSidelinePackageCount", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_PACKAGE_METRIC, MetricType.FAILED);
    }
}

/** Fetch pick status updates in grid - list of available picklists per aisle group **/
export function getPickStatusInGrid(dispatcher, baseUrl, capability, stationConfig, configDispatch, xptNodes) {
    fetchPickStatusInGridFromRSWS(dispatcher, baseUrl, capability, stationConfig, configDispatch, xptNodes)
}

async function fetchPickStatusInGridFromRSWS(dispatcher, baseUrl, capability, stationConfig, configDispatch, xptNodes) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        let mainUri = `/apigw/picklists/status_in_grid/station/${stationCode}`;
        let requestBody = {
            "date": [getDateInMMDDYYYYWithOffset(0)]
        };
        if (DEFAULT_CAPABILITIES.includes(capability) && Array.isArray(xptNodes) && xptNodes.length) {
            const nodeList = [...xptNodes];
            requestBody = {
                "date": [getDateInMMDDYYYYWithOffset(0)],
                "nodes": [nodeList.join(",")]
            };
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: mainUri,
                httpMethod: "get",
                processName: "routeStaging",
                requestParams: requestBody
            };
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            mainUri = `/rsws/picklists/status_in_grid/station/${stationCode}?date=${getDateInMMDDYYYYWithOffset(0)}`;
            if (DEFAULT_CAPABILITIES.includes(capability) && Array.isArray(xptNodes) && xptNodes.length) {
                const nodeList = [...xptNodes];
                mainUri = `${mainUri}&nodes=${nodeList.join(",")}`;
            }
            response = await api.get(mainUri);
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_PICK_STATUS_IN_GRID, MetricType.SUCCESS);
            const output = response.data;
            const lastUpdated = new Date().getTime();
            dispatcher({type: "UPDATE_PICK_STATUS_IN_GRID_DATA_CACHE",
                data: {response: output, xptNodes: xptNodes, stationCode: stationCode},
                lastUpdated: lastUpdated});
            dispatcher({type: "RECEIVE_PICK_STATUS_IN_GRID_DATA",
                response: output,
                lastUpdated: lastUpdated});
            configDispatch({
                type: 'RECEIVE_REFRESH_INTERVAL',
                data: {
                    refreshInterval: output.pickStatusInGridRefreshRate
                }
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in PickNetworkAPI.getPickStatusInGrid" , error);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_PICK_STATUS_IN_GRID, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getPickStatusInGrid", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_PICK_STATUS_IN_GRID, MetricType.FAILED);
    }
}

function extractSidelinedPackageCount(output) {
    if (Array.isArray(output.values) && output.values.length > 0) {
        let metricModel = output.values[0];
        if (Array.isArray(metricModel.metricList) && metricModel.metricList.length > 0) {
            let metricObj = metricModel.metricList[0];
            if (metricObj.metric === "SIDELINED") {
                return metricObj.metricValue;
            }
        }
    }
    return 0;
}

async function getInductedPackageCount(dispatcher) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        let filterMap = {
            'Cycle': ["CYCLE_1"] //TODO:
        }
        const requestBody = {
            nodeId: stationCode,
            groupBy: 'Node',
            filters: filterMap,
            metricList: ["INDUCTED_AT_STATION"]
        }
        const requestPayload = {
            resourcePath: "/ivs/getPackageMetric",
            httpMethod: "post",
            processName: "induct",
            requestBody: requestBody
        }
        getAPIGatewayDataFromParent(requestPayload).then(result => {
            if (result.status === 200) {
                const output = result.data.groupedPackageMetrics
                logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, IVS_GET_PACKAGE_METRIC, MetricType.SUCCESS);
                dispatcher({
                    type: "RECEIVE_INDUCTED_COUNT",
                    data: {inductedPackageCount: (output.INDUCTED_AT_STATION)[stationCode]}
                });
            } else {
                logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, IVS_GET_PACKAGE_METRIC, MetricType.FAILED);
            }
        });
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getInductedPackageCount", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, IVS_GET_PACKAGE_METRIC, MetricType.FAILED);
    }
}

async function getRouteInformation(dispatcher, filterDispatcher, baseUrl, capability, xptNodes, stationConfig, configDispatch) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_GET_STATION_ROUTES_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = getRouteRequestPayload(capability, xptNodes);
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get(getRouteRequestURL(capability, xptNodes));
        }
        if (response && response.status === 200) {
            const output = response.data;
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.SUCCESS);
            const lastUpdated = new Date().getTime()
            dispatcher({type: "UPDATE_ROUTE_DATA_CACHE",
                data: {response: output, xptNodes: xptNodes, stationCode: stationCode},
                lastUpdated: lastUpdated});
            dispatcher({type: "RECEIVE_DATA",
                data: convertRoutesToUIModel(output, capability, stationConfig),
                lastUpdated: lastUpdated});
            filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(output)})
            configDispatch({
                type: 'RECEIVE_REFRESH_INTERVAL',
                data: {
                    refreshInterval: output.routeRefreshRate
                }
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in PickNetworkAPI.getRouteInformation" , error);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getRouteInformation", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, error);
    }
}

function getRouteRequestPayload(capability, xptNodes) {
    const mainUri = `/apigw/route/station/${getStationCode()}`;
    if (DEFAULT_CAPABILITIES.includes(capability) && Array.isArray(xptNodes) && xptNodes.length) {
        const nodeList = [...xptNodes];
        const requestBody = {
            "date": [getDateInMMDDYYYYWithOffset(0)],
            "nodes": [nodeList.join(",")]
        }
        const requestPayload = {
            resourcePath: mainUri,
            httpMethod: "get",
            processName: "routeStaging",
            requestParams: requestBody
        }
        return requestPayload;
    } else {
        const requestBody = {
            "date": [getDateInMMDDYYYYWithOffset(0)]
        }
        const requestPayload = {
            resourcePath: mainUri,
            httpMethod: "get",
            processName: "routeStaging",
            requestParams: requestBody
        }
        return requestPayload;
    }
}

function getRouteRequestURL(capability, xptNodes) {
    const mainUri = `/rsws/route/station/${getStationCode()}?date=${getDateInMMDDYYYYWithOffset(0)}`;
    if (DEFAULT_CAPABILITIES.includes(capability) && Array.isArray(xptNodes) && xptNodes.length) {
        const nodeList = [...xptNodes];
        return `${mainUri}&nodes=${nodeList.join(",")}`;
    } else {
        return mainUri;
    }
}

export function convertRoutesToUIModel(response, capability, stationConfig) {
    let routes = response.routes;
    const model = {
        totalRoutes: routes.length,
        routeNotAssigned: 0,
        routeInProgress: 0,
        routePicked: 0,
        routeList: [],
    }

    routes = handleUnassignedRoutes(capability, routes, stationConfig);
    routes = enrichDisplayPriority(routes, stationConfig);
    routes.forEach(route => {
        switch (route.routeStatus) {
            case ASSIGNABLE:
                //for ARv2 this is provided by backend( overwritten below)
                model.routeNotAssigned++;
                break;
            case IN_PROGRESS:
                model.routeInProgress++;
                break;
            default:
                break;
        }
        try {
            const routeDetail = getRouteUIModel(route, capability, stationConfig);
            model.routeList.push(routeDetail);
            if (routeDetail.status === "Picked") {
                model.routePicked++;
            }
        } catch (e) {
            Logger.error("Exception in PickNetworkAPI.convertRoutesToUIModel", e);
            logErrorMetric(getStationCode(), GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
        }
    })
    if (capability === AR_V2) {
        model.routeNotAssigned = response.routesNotAssignedCount ? response.routesNotAssignedCount : 0;
    }
    return model
}

/**
 * Note: Un-assignment handling and pick priority enrichment is not done in this method.
 *
 * @param route
 * @param capability
 * @param stationConfig
 * @return ui model of route
 */
function getRouteUIModel(route, capability, stationConfig){
    route.criticalPullTime = getDispatchTime(route, capability);
    route.pickAssociates = formatPickAssociates(route.pickAssociates);
    route.pickAssociatesAlias = getUniquePickerAlias(route.pickAssociates);
    route.stagingLocations = transformStagingLocations(route);
    let pickDurationInSeconds = getPickDurationInSeconds(route, capability, stationConfig);
    pickDurationInSeconds = (pickDurationInSeconds > 0) ? pickDurationInSeconds : null;
    const picklistUIModel = convertPicklistToUIModel(route, route.picklists, stationConfig);

    const routeDetail = {
        routeId: route.routeId,
        routeCode: route.routeCode,
        stationCode: route.stationCode,
        routeType: route.type,
        algorithm: route.algorithm,
        routeSLA: calculatePickSLA(route, capability),
        pickProgress: getPickProgress(route, capability, stationConfig),
        rswsPickProgress: route.pickProgress,
        lastPickCompletionTime: route.pickProgress.lastCompletionTime ? convertEpochMillisToLocalTime(route.pickProgress.lastCompletionTime) : null,
        status: getPickStatus(route, capability, stationConfig, pickDurationInSeconds),
        routeStatus: getRouteStatus(route, stationConfig),
        picker: formatAlias(getLatestAssignee(route)),                          /* latest/first picker name */
        pickerAlias: getLatestAssignee(route),                                  /* latest/first picker email */
        pickAssociates: route.pickAssociates,                                   /* list of all pickers */
        pickAssociatesAlias: route.pickAssociatesAlias,                         /* list of unique pickers */
        totalPickerCount: route.pickAssociatesAlias.length,                     /* count of unique pickers */
        pickDurationInSeconds: pickDurationInSeconds,                           /* overall picking duration in seconds */
        pickDuration:  convertPickDuration(pickDurationInSeconds),              /* picking duration in display format */
        startTime: getRouteStartTime(route),                                    /* first picker start time */
        endTime: getRouteEndTime(route),                                        /* first picker end time */
        criticalPullTime: route.criticalPullTime,
        priority: route.priority,
        pickPriority: route.pickPriority ? route.pickPriority : 0,
        aisles: getAisles(route),
        assignedWorkGroups: getAssignedWorkGroupsForRoute(route),
        nextWorkGroups: getNextWorkGroupsForRoute(picklistUIModel),
        cartAssigned: capability === AR_V2 ? route.plannedCartsCount : route.carts ? route.carts.length : 0,
        hazmatWeight: route.hazmatWeight ? route.hazmatWeight : "...",
        departProgress: route.departProgress.completedCount +"/" + route.departProgress.totalCount,
        stowProgress: getStowProgress(route.stowProgress.completedCount, route.stowProgress.totalCount),
        stagingLocations: route.stagingLocations,           /* Represents list of staging location objects */
        stagingLocation: getRouteStagingLocation(route),    /* Represents display label for staging location */
        stationPairs: getStationPairs(route),
        ovCount: route.itemsCount && route.itemsCount.ovCount >= 0 ? route.itemsCount.ovCount : null,
        bagCount: route.itemsCount && route.itemsCount.bagCount >= 0 ? route.itemsCount.bagCount : null,
        routeSPR: route.plannedPackagesCount ? route.plannedPackagesCount : null,
        picklists: picklistUIModel,
        carts: convertCartsToUIModel(route, capability, stationConfig),
        stageListId: extractStageListId(route, capability),
        routeSpeed: route.routeSpeed ? route.routeSpeed : null
    }

    return routeDetail;
}

function convertCartsToUIModel(route, capability, stationConfig) {
    if ((capability === CORE_AMZL || stationConfig.routeDetailsTabViewEnabled) && Array.isArray(route.carts)) {
        const cartList = [];
        route.carts.forEach(cart => {
            const cartDetail = {
                cartId: cart.cartId,
                stagingLocation: getCartStagingLocation(route, cart),
                stageTime: cart.stageTime,
                dwellDuration: cart.dwellDuration,
                routeSequenceNumber: cart.routeSequenceNumber,
                preStageLocation: cart.preStageLocation
            }
            cartList.push(cartDetail)
        })
        return cartList;
    }
    return [];
}

function getRouteStartTime(route){
    if(route.pickAssociates.length && route.pickAssociates[0].startTime) {
         return convertEpochMillisToLocalTime(route.pickAssociates[0].startTime)
    }
    return "...";
}

function getRouteEndTime(route){
    if(route.pickAssociates.length && route.pickAssociates[0].endTime) {
        return convertEpochMillisToLocalTime(route.pickAssociates[0].endTime)
    }
    return "...";
}

function convertPickDuration(pickDurationInSeconds) {
    if (pickDurationInSeconds) {
        return convertSecondsToTimeFormat(pickDurationInSeconds);
    } else {
        return "...";
    }
}

function getPickDurationInSeconds(route, capability, stationConfig) {
    if (capability === AR_V2 || stationConfig.parallelPickEnabled) {
        return calculatePickDurationWithMultipleAssociates(route)
    } else {
        return calculatePickDurationWithSingleAssociate(route)
    }
}

function convertPicklistToUIModel(route, picklists, stationConfig) {
    if (Array.isArray(picklists)) {
        const result = [];
        picklists.forEach(picklist => {
            picklist.pickAssociates = formatPickAssociates(picklist.associates);
            const latestPicker = getLatestPickerDetails(picklist.pickAssociates);
            const pickDurationInSeconds = calculatePickDurationWithMultipleAssociates(picklist);
            const picklistModel = {
                routeId: route.routeId,
                routeCode: route.routeCode,
                stationCode: route.stationCode,
                picklistId: picklist.id,
                picklistCode: picklist.code,
                pickProgress: getPicklistProgress(picklist, stationConfig),
                status: getPickStatusForPicklist(picklist, stationConfig),
                ovCount: picklist.itemsCount.ovCount,
                bagCount: picklist.itemsCount.bagCount,
                aisles: getAisles(picklist),
                picker: latestPicker ? latestPicker.alias : "-",            /* latest picker name */
                pickerAlias: latestPicker ? latestPicker.emailId : "-",     /* latest picker email */
                startTime: latestPicker ? latestPicker.startTime: "-",      /* latest picker start time */
                endTime: latestPicker ? latestPicker.endTime: "-",          /* latest picker end time */
                pickAssociates: picklist.pickAssociates,                    /* list of all pickers */
                pickDuration: convertPickDuration(pickDurationInSeconds),   /* overall picking duration */
                pickDurationInSeconds: pickDurationInSeconds,
                workGroupSequenceList: picklist.workGroupSequence,
                picklistType: picklist.picklistType,
                assignedWorkGroupLabel: picklist.assignedWorkGroupLabel,
                nextWorkGroups: getNextWorkGroups(picklist),
                carts: convertPicklistCartsToUIModel(picklist, stationConfig)
            }
            result.push(picklistModel);
        })

        /** Sort in asc order by code **/
        sortList(result, "picklistCode", SORT_DIRECTION.ASC);

        return result;
    }
    return [];
}

function convertPicklistCartsToUIModel(picklist, stationConfig) {
    if (stationConfig && stationConfig.routeDetailsTabViewEnabled && Array.isArray(picklist.carts)) {
        const cartList = [];
        picklist.carts.forEach(cart => {
            const cartDetail = {
                cartId: cart.cartId,
                stagingLocation: cart.stagingLocation ? getDisplayLabel(cart.stagingLocation) : '...',
                stageTime: cart.stageTime,
                dwellDuration: cart.dwellDuration,
                routeSequenceNumber: cart.routeSequenceNumber,
                preStageLocation: cart.preStageLocation
            }
            cartList.push(cartDetail)
        })
        return cartList;
    }
    return [];
}

/**
 * Returns the latest pick associate based on flag passed by backend.
 *
 * Note: Currently isLatest is sent by backend only for parallel pick programme
 * @param pickAssociates
 */
export function getLatestPickerDetails(pickAssociates) {
    if (Array.isArray(pickAssociates) && pickAssociates.length > 0) {
        const latestPickerList = pickAssociates
            .filter(associate => associate.latest)
            .map(associate => {
                const cloneObj = {...associate};
                cloneObj.startTime = associate.startTime ? convertEpochMillisToLocalTime(associate.startTime) : "-";
                cloneObj.endTime = associate.endTime ? convertEpochMillisToLocalTime(associate.endTime) : "-";
                return cloneObj;
            });
        return latestPickerList.length ? latestPickerList[0] : null;
    }
    return null;
}

/**
 * Return the assignee for AMZL sites
 * if route is not picked yet we use RPS information
 * if route is picked we use SPS information
 *
 * @param rswsRoute
 * @return {*|string}
 */
export function getLatestAssignee(rswsRoute) {
    if (rswsRoute.activeAssignee) {
        return rswsRoute.activeAssignee;
    } else if (rswsRoute.routeStatus === ASSIGNABLE) {
        return '...';
    } else {
        return Array.isArray(rswsRoute.pickAssociates) && rswsRoute.pickAssociates.length ?
            rswsRoute.pickAssociates[0].alias : '...';
    }
}

/**
 * return driver arrival time if available else fallback to RTW dispatch time.
 * @param route
 * @param capability
 * @return {*}
 */
function getDispatchTime(route, capability){
    if(capability === CORE_AMZL && route.plannedDispatchTime){
        return route.plannedDispatchTime;
    }
    return route.criticalPullTime;
}

function isRoutePrioritizable(route, stationConfig) {
    if (stationConfig && stationConfig.parallelPickEnabled && route.picklists) {
        return route.picklists.some(picklist => (picklist.status === ASSIGNABLE  || picklist.status === NOT_ASSIGNED));
    } else {
        return route.routeStatus === ASSIGNABLE;
    }
}

export function enrichDisplayPriority(routeList, stationConfig) {
    //Initialise priority station wise.
    let priorityMap = routeList.reduce((map, route) => {
        map[route.stationCode] = 1;
        return map;
    }, {});

    //sort all routes by pickPriority.
    routeList.sort((a, b) => {
        const pickPriorityA = a.pickPriority ? a.pickPriority : 0;
        const pickPriorityB = b.pickPriority ? b.pickPriority : 0;
        return pickPriorityA - pickPriorityB;
    });

    //assign display priority station wise.
    routeList.forEach(route => {
        if (isRoutePrioritizable(route, stationConfig)) {
            route.priority = priorityMap[route.stationCode]++;
        } else {
            route.priority = null;
            route.pickPriority = Number.MAX_SAFE_INTEGER;
        }
    });

    //sort by station code
    routeList.sort((a, b) => {
        return a.stationCode.localeCompare(b.stationCode);
    });
    return routeList;
}

export function getFilterData(output) {
    const data = {
        departure: new Set(),
        pickByTime: new Set(),
        driverType: new Set(["DSP", "DP"]),
        cluster: new Set(),
    }
    output.routes.forEach(route => {
        route.carts = route.carts.filter(cart => {
            return (cart.preStageLocation !== null && cart.preStageLocation !== '')
        })
        if (route.type !== "...") {
            data.driverType.add(route.type)
        }
        data.cluster.add(getCluster(route.routeCode));
        if (route.criticalPullTime != null) {
            data.departure.add(convertSecondsToHHMM(route.criticalPullTime));
        }
        if (route.pickCutOffTime != null) {
            data.pickByTime.add(convertSecondsToHHMM(route.pickCutOffTime));
        }
    })
    return data;
}

function getPickProgress(rswsRoute, capability, stationConfig) {
    if (capability === AR_V2 || stationConfig.pickStageDecoupleEnabled || !rswsRoute.pickProgressV2) {
        return rswsRoute.pickProgress.completedCount + "/" + rswsRoute.pickProgress.totalCount;
    } else {
        return rswsRoute.pickProgressV2.completedCount + "/" + rswsRoute.pickProgressV2.totalCount;
    }
}

//RSWS response won't have completed count and this function rely on SVS response for numerator
function getStowProgress(completedStowedPackage, totalStowedPackage) {
    return completedStowedPackage + "/" + totalStowedPackage;
}

function calculatePickSLA(route, capability) {
    if (capability === AR_V2 && route.pickCutOffTime) {
        return convertSecondsToHHMM(route.pickCutOffTime);
    } else if (capability !== AR_V2 && route.criticalPullTime) {
        return convertSecondsToHHMM(route.criticalPullTime);
    } else {
        return "...";
    }
}

/** Fetch Route Content **/
export function fetchRouteContent(routeId, dispatcher, baseUrl, capability, routeStatus, stationCode, stationConfig) {
    if (stationConfig && stationConfig.routeDetailsTabViewEnabled) {
        getRouteContentFromRSWS(routeId, dispatcher, baseUrl, capability, routeStatus, stationCode, stationConfig);   /* to fetch complete RouteContent with stow progress for Core + Grocery routes from RSWS */
    } else if (isARorSSD(capability)) {
        getRouteContentForArSSD(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig);
    } else if (capability === AR_V2) {
        getContainersForARv2(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig);
    } else {
        getRouteContent(routeId, dispatcher, baseUrl, stationCode, capability, stationConfig)
    }
    dispatcher({
        type: "HIDE_LOADER"
    });

}

async function getRouteContentFromRSWS(routeId, dispatcher, baseUrl, capability, routeStatus, stationCode, stationConfig) {
    try {
        const response = await getContainersFromRSWS(routeId, baseUrl, stationConfig, stationCode);
        if(response) {
            const output = response.data;
            dispatcher({
                type: "RECEIVE_DATA",
                data: convertRouteDetailResponse(output, capability, stationConfig, null)
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getRouteContentFromRSWS", error);
        logErrorMetric(stationCode, GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }
}

async function getContainersForARv2(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig) {
    const data = await getContainersFromStowPickStageDepart(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig);
    if (data) {
        dispatcher({
            type: "RECEIVE_DATA",
            data: {
                containers: data.containers,
                hazmatWeight: data.hazmatWeight
            }
        });
    }
}

function filterParentContainerPackages(parentContainers) {
    return parentContainers.filter(parentContainer => parentContainer.containerType === 'PACKAGE');
}

function getDropToCartPackages(svsPackages, rswsParentConatinerPackages) {
    return svsPackages.map(svsPackage => {
        // get matching RSWS parent container packages
        const matchingRSWSPackage = rswsParentConatinerPackages.find(rswsPackage => rswsPackage.id === svsPackage.trackingId);
        if (matchingRSWSPackage) {
            const containerStates = matchingRSWSPackage.containerStates || [];
            const isNotPickedStagedOrDeparted = !containerStates.includes("PICKED") && 
                                                !containerStates.includes("STAGED") && 
                                                !containerStates.includes("DEPARTED") &&
                                                svsPackage.state === PACKAGE_STATUS.STOW_SUCCESS;
            if (isNotPickedStagedOrDeparted) {
                return { ...svsPackage, state: PACKAGE_STATUS.STOWED_SHELF };
            }
        } 
        return svsPackage 
    })
}

export function filterPicklistStatuses(picklists) {
    // Check if input is valid
    if (!picklists || !Array.isArray(picklists)) {
        return [];
    }
    let status = []
    picklists.forEach(picklist => {
        picklist.status && status.push(picklist.status)
    })
    return status;
}

async function getContainersFromStowPickStageDepart(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig) {
    try {
        const result = await Promise.all([
            getContainersFromRSWS(routeId, baseUrl, stationConfig, stationCode),
            getContainersFromSVS(routeId),
            getFloorData(routeId)
        ]);
        const rswsCarts = result[0] && result[0].status === 200 ? filterCartContainers(result[0].data.parentContainers) : [];
        const rswsPackages = result[0] && result[0].status === 200 ? result[0].data.containers : [];
        const rswsParentConatinerPackages = result[0] && result[0].status === 200 && result[0].data.parentContainers ? filterParentContainerPackages(result[0].data.parentContainers) : [];
        const hazmatWeight = result[0] && result[0].status === 200 ? result[0].data.hazmatWeight : '...';
        let svsPackages = result[1] && result[1].status === 200 ? result[1].data.packages : [];
        const floorData = result[2] && result[2].status === 200 ? result[2].data.floors : [];
        const rswsPicklistStatuses = result[0] && result[0].status === 200 && result[0].data.route ? filterPicklistStatuses(result[0].data.route.picklists) : [];

        //Filter SVS Packages only if flag is enabled.
        if (stationConfig.filterReplannedPackagesFromRouteDetailView) {
            svsPackages = getFilteredSVSPackagesFromRSWSPackages(svsPackages, rswsPackages);
        }
        //Modify SVS Packages for DropToCart Packages.
        if (stationConfig.dropToCartEnabled) {
            //Update SVS Package state to STOW_SHELF for stowed rebin shelf packages marked PICKED 
            svsPackages = getDropToCartPackages(svsPackages, rswsParentConatinerPackages);
        }
        return {
            rswsOutput: result[0].data,
            containers: mergeStowPickandDepartContainers(rswsCarts, rswsPackages, svsPackages, floorData, routeId, routeStatus, capability, stationConfig, rswsPicklistStatuses),
            hazmatWeight: hazmatWeight
        };
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getContainersFromStowPickStageDepart", error);
        logErrorMetric(stationCode, GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }
}

async function getDRSContainersFromStowPickStageDepart(routeId, dispatcher, baseUrl, stationCode, rswsContainers) {
    const svsResponse = await getContainersFromSVS(routeId);
    const svsPackages = svsResponse && svsResponse.status === 200 ? svsResponse.data.packages : [];
    return mergeStowPickAndDepartDRSContainers(rswsContainers, svsPackages)
}

 function filterCartContainers(parentContainers) {
    return parentContainers.filter(parentContainer => parentContainer.containerType === 'CART');
}

function getFilteredSVSPackagesFromRSWSPackages(svsPackages, rswsPackages) {
    //Finds and filters svsPackage in rwsPackages list by comparing label (SVS) and trackingId (RSWS).
    return svsPackages
        .filter(svsPackage => rswsPackages.find(rswsPackage => rswsPackage.label === svsPackage.trackingId));
}

async function getRouteContentForArSSD(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig) {
    const data = await getContainersFromStowPickStageDepart(routeId, dispatcher, baseUrl, routeStatus, stationCode, capability, stationConfig);
    if (data) {
        dispatcher({
            type: "RECEIVE_DATA",
            data: convertRouteDetailResponse(data.rswsOutput, capability, stationConfig, data.containers)
        });
    }
}


function getBagContainerFromSVSPackage(svsPackage) {
    return {
        label: svsPackage.sortLocation.bag,
        location: svsPackage.sortLocation.bin,
        picked: false,
        stowed: false,
        staged: false,
        departed: false
    }
}

function getPackageContainerFromSVSPackage(svsPackage) {
    return {
        label: svsPackage.trackingId,
        location: svsPackage.sortLocation.bin,
        picked: false,
        stowed: false,
        staged: false,
        departed: false
    }
}

function getPackageContainerFromRSWSPackage(rswsPackage) {
    return {
        label: rswsPackage.label,
        location: "...",
        picked: false,
        stowed: false,
        staged: false,
        departed: false
    }
}

function mergeStowPickandDepartContainers(rswsCarts, rswsPackages, svsPackages, floorData, routeId, routeStatus, capability, stationConfig, rswsPicklistStatuses) {
    //List of carts
    const allCarts = extractAllCarts(rswsCarts, svsPackages, floorData, routeId, routeStatus, stationConfig);

    //All Bags
    const bagPackageMapping = {};
    svsPackages
        .filter(svsPackage => svsPackage.sortLocation.bag && svsPackage.sortLocation.cart && svsPackage.state === PACKAGE_STATUS.STOW_SUCCESS)
        .forEach(svsPackage => {
            const cartIndex = allCarts.findIndex(cart => cart.name === svsPackage.sortLocation.cart);
            if (cartIndex >= 0) {
                const bagIndex = allCarts[cartIndex].bags.findIndex(bag => bag.label === svsPackage.sortLocation.bag);
                if (bagIndex === -1) {
                    const container = getBagContainerFromSVSPackage(svsPackage);
                    container.stowed = true;
                    allCarts[cartIndex].bags.push(container);
                }

                //save mapping
                if (bagPackageMapping[svsPackage.sortLocation.bag]) {
                    bagPackageMapping[svsPackage.sortLocation.bag].push(svsPackage.trackingId);
                } else {
                    bagPackageMapping[svsPackage.sortLocation.bag] = [svsPackage.trackingId];
                }
            }
        });

    //Ov stowed packages
    svsPackages
        .filter(svsPackage => !svsPackage.sortLocation.bag && PACKAGE_STATUS.STOW_SUCCESS === svsPackage.state)
        .forEach(svsPackage => {
            const cartIndex = allCarts.findIndex(cart => cart.name === svsPackage.sortLocation.cart);
            if (cartIndex >= 0) {
                // OV package or loose package
                const container = getPackageContainerFromSVSPackage(svsPackage);
                container.stowed = true;
                allCarts[cartIndex].packages.push(container);
            }
        });

    // Add NotInCart
    populateNotInCartPackages(allCarts, svsPackages, rswsPackages, NOT_IN_CART_ELIGIBLE_STATUSES, NOT_IN_CART, capability);

    // Add RouteRemovedPackages
    populateNotInCartPackages(allCarts, svsPackages, rswsPackages, [PACKAGE_STATUS.PENDING_REPLAN], "Removed Packages", capability);

    //enrich pick, stage and depart progress for all packages
    allCarts.forEach(cart => {
        cart.packages.forEach(_package => {
            const rswsPackage = rswsPackages.find(p => p.id === _package.label);
            if (rswsPackage) {
                _package.pickedV2 = stationConfig.dropToCartEnabled
                    && cart.name !== NOT_IN_CART 
                    && rswsPicklistStatuses.length > 0
                    && PICK_VISIBILITY_DROP_TO_CART_STATUS.includes(rswsPicklistStatuses[0])
                _package.picked = rswsPackage.containerStates.includes("PICKED");
                _package.staged = cart.staged;
                _package.departed = rswsPackage.containerStates.includes("DEPARTED");
            }
        })
    });

    //enrich stage and depart progress for all bags
    allCarts.forEach(cart => {
        cart.bags.forEach(bag => {
            bag.staged = cart.staged;

            //if any package inside bag is departed, bag is departed.
            bagPackageMapping[bag.label].forEach(trackingId => {
                const rswsPackage = rswsPackages.find(p => p.id === trackingId);
                if (rswsPackage && rswsPackage.containerStates.includes("DEPARTED")) {
                    bag.departed = true;
                }
            });
        })
    });

    //enrich cart depart progress and cartType
    allCarts
        .filter(cart => !cart.isNotInCart)
        .forEach(cart => {
            //cart type
            cart.isNotOVCart = cart.bags.length > 0;

            //if any bags/package is not departed then cart is not departed
            if (cart.isNotOVCart) {
                if (cart.bags.length > 0
                    && !cart.bags.find(bag => !bag.departed)) {
                    cart.status = DEPARTED;
                }
            } else {
                if (cart.packages.length > 0
                    && !cart.packages.find(_package => !_package.departed)) {
                    cart.status = DEPARTED;
                }
            }
        });

    return allCarts;
}

function enrichWithRSWSContainer(container, rswsContainer) {
    return {
        ...container,
        picked: rswsContainer.containerStates.includes("PICKED"),
        pickedV2: rswsContainer.containerStates.includes("PICKED_V2"),
        staged: rswsContainer.containerStates.includes("STAGED"),
        departed: rswsContainer.containerStates.includes("DEPARTED"),
        sequenceNumber: rswsContainer.sequenceNumber
    }
}

function mergeStowPickAndDepartDRSContainers(rswsContainers, svsPackages) {

    //List of carts
    const allCarts = [];

    // All packages from SVS hierarchy
    svsPackages.forEach(svsPackage => {

        // Generate bag or packages based on Stow location
        let container = svsPackage.sortLocation.bag ?
            getBagContainerFromSVSPackage(svsPackage) :
            getPackageContainerFromSVSPackage(svsPackage);

        // Update stow status
        container.stowed = svsPackage.state === PACKAGE_STATUS.STOW_SUCCESS;

        // Fetch and enrich info from RSWS responses for the package/bag if available
        const rswsContainer = rswsContainers.find(container => (container.label === svsPackage.sortLocation.bag) || (container.label === svsPackage.trackingId));
        const picklistId = rswsContainer && rswsContainer.picklistId;
        const parentLabel = rswsContainer && rswsContainer.parentResourceLabel ? rswsContainer.parentResourceLabel : NOT_IN_CART;
        const stageAssociate = rswsContainer && rswsContainer.parentAssignee ? formatAlias(rswsContainer.parentAssignee) : "...";

        container = rswsContainer ? enrichWithRSWSContainer(container, rswsContainer) : container;

        // Find the cart to which this package/bag belongs
        const cartIndex = allCarts.findIndex(cart => cart.name === parentLabel && (!picklistId || picklistId === cart.picklistId));

        // Add the bag/package to a cart
        if (cartIndex !== -1) {
            // Check if the container is bag/package to push into existing cart
            if (svsPackage.sortLocation.bag) {
                // Don't push bag if already present
                const bagIndex = allCarts[cartIndex].bags.findIndex(bag => bag.label === svsPackage.sortLocation.bag);
                if (bagIndex === -1) {
                    allCarts[cartIndex].bags.push(container);
                }
            } else {
                allCarts[cartIndex].packages.push(container);
            }
            // Update sequence number based on the new container
            allCarts[cartIndex].sequenceNumber = Math.min(allCarts[cartIndex].sequenceNumber, container.sequenceNumber)
        } else {
            // Create a new cart if not already present
            allCarts.push({
                name: parentLabel,
                stageAssociate: stageAssociate,
                packages: (!svsPackage.sortLocation.bag) ? [container] : [],
                bags: (svsPackage.sortLocation.bag) ? [container] : [],
                sequenceNumber: rswsContainer && rswsContainer.sequenceNumber,
                picklistId: picklistId ? picklistId : "..."
            });
        }
    });

    // Sort bags and ovs inside each cart
    allCarts.forEach(cart => {
        sortObjectsBySequenceNumber(cart.bags)
        sortObjectsBySequenceNumber(cart.packages)
    });

    // Sort carts
    sortObjectsBySequenceNumber(allCarts);

    return allCarts;
}

function populateNotInCartPackages(allCarts, svsPackages, rswsPackages, eligibleStatuses, name, capability) {
    const packages = svsPackages
        .filter(svsPackage => eligibleStatuses.includes(svsPackage.state))
        .map(svsPackage => {
            let packageContainer = getPackageContainerFromSVSPackage(svsPackage);
            if (svsPackage.state === PACKAGE_STATUS.STOWED_SHELF) {
                packageContainer.stowed = true;
            }
            return packageContainer;
        })
    // Add Not ready packages
    if (name === NOT_IN_CART && isARorSSD(capability)) {
        rswsPackages
            .filter(rswsPackage => !svsPackages.find(svsPackages => svsPackages.trackingId === rswsPackage.label && svsPackages.state !== null))
            .forEach(rswsPackage => packages.push(getPackageContainerFromRSWSPackage(rswsPackage)));
    }

    if (packages.length > 0) {
        allCarts.push({
            name: name,
            staged: false,
            packages: packages,
            bags: [],
            isNotInCart: true,
            isNotOVCart: false
        });
    }
}

function extractAllCarts(rswsCarts, svsPackages, floorData, routeId, routeStatus, stationConfig) {
    let isRswsCartStaged = false;

    //List of carts
    const allCarts = rswsCarts.reduce((cartList, cart) => {
        cart.containerStates.includes("STAGED") && (isRswsCartStaged = true);
        cartList.push({
            name: cart.label,
            stageAssociate: cart.assignee ? cart.assignee : "",
            staged: cart.containerStates.includes("STAGED"),
            status: getCartStatusARv2(cart, routeStatus),
            bags: [],
            packages: []
        });
        return cartList;
    }, []);

    //Add carts from Stow
    svsPackages
        .filter(svsPackage => svsPackage.sortLocation.cart && svsPackage.state === "STOW_SUCCESS")
        .forEach(svsPackage => {
            const cartIndex = allCarts.findIndex(cart => cart.name === svsPackage.sortLocation.cart);
            if (cartIndex >= 0) {
                allCarts[cartIndex].floor = svsPackage.sortLocation.floor;
            } else {
                allCarts.push({
                    name: svsPackage.sortLocation.cart,
                    floor: svsPackage.sortLocation.floor,
                    stageAssociate: "",
                    status: routeStatus === SIDELINED ? SIDELINED : NOT_READY,
                    staged: stationConfig.dropToCartEnabled && isRswsCartStaged, 
                    bags: [],
                    packages: []
                });
            }
        });

    //update status from floorData
    floorData.forEach(floor => {
        if (floor.routeId !== routeId || !floor.cart || !floor.cart.label) {
            return;
        }

        const cartIndex = allCarts.findIndex(cart => cart.name === floor.cart.label);
        if (cartIndex >= 0
            && allCarts[cartIndex].status !== SIDELINED
            && allCarts[cartIndex].status !== STAGED
            && allCarts[cartIndex].status !== MISSING) {

            if (floor.cart.status === 'STOW_COMPLETE') {
                allCarts[cartIndex].status = READY;
            }
        }
    });

    return allCarts;
}

async function getRouteContent(routeId, dispatcher, baseUrl, stationCode, capability, stationConfig) {
    try {
        const response = await getContainersFromRSWS(routeId, baseUrl, stationConfig, stationCode);
        if(response) {
            let containers = null;
            const output = response.data;

            // Fetch details from Stow for dynamic route
            if (output.route && isDynamicRoute(output.route.algorithm) && stationConfig.drsPickStageVisibilityEnabled) {
                containers = await getDRSContainersFromStowPickStageDepart(routeId, dispatcher, baseUrl, stationCode, output.containers);
            }

            dispatcher({
                type: "RECEIVE_DATA",
                data: convertRouteDetailResponse(output, capability, stationConfig, containers && containers.length ? containers : null)
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.getRouteContent", error);
        logErrorMetric(stationCode, GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }
}

async function getContainersFromRSWS(routeId, baseUrl, stationConfig, stationCode) {
    const startTime = Date.now();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestBody = {
                "date": [getDateInMMDDYYYYWithOffset(0)]
            }
            const requestPayload = {
                resourcePath: "/apigw/route/" + routeId + "/stationCode/" + stationCode,
                httpMethod: "get",
                processName: "routeStaging",
                requestParams: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get("/rsws/route/" + routeId + "/stationCode/" + stationCode + "?date=" + getDateInMMDDYYYYWithOffset(0));
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_ROUTE_DETAIL_METRIC, MetricType.SUCCESS);
            return response;
        } else {
            var error = {
                response : response
            }
            Logger.error("Response for GetContainersFromRSWS : " , error);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_ROUTE_DETAIL_METRIC, MetricType.FAILED, error);
        }
    } catch (e) {
        Logger.error("Exception in PickNetworkAPI.getContainersFromRSWS", e);
        logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_ROUTE_DETAIL_METRIC, MetricType.FAILED, e);
    }
    return null;
}

async function getContainersFromSVS(routeId) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const filterMap = {
            'NODE': [stationCode],
            "ROUTE_ID": [routeId],
        }
        const requestBody = {
            fieldsRequired: ["BAG_DATA", "CART_DATA", "FLOOR_DATA"],
            filters: filterMap
        }
        const requestPayload = {
            resourcePath: "svs/packages/data",
            httpMethod: "post",
            processName: "stow",
            requestBody: requestBody
        }
        const response = await getAPIGatewayDataFromParent(requestPayload);
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, SVS_PACKAGE_HIERARCHY_METRIC, MetricType.SUCCESS);
        } else {
            Logger.error("PickNetworkAPI.getContainersFromSVS failed with error" , response);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, SVS_PACKAGE_HIERARCHY_METRIC, MetricType.FAILED);
        }
        return response;
    } catch (e) {
        Logger.error("Exception in PickNetworkAPI.getContainersFromSVS", e);
        logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, SVS_PACKAGE_HIERARCHY_METRIC, MetricType.FAILED);
    }
    return null;
}

async function getFloorData(routeId) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const filterMap = {
            'NODE': [stationCode],
            'SORT_GROUP_ID': [routeId]
        }
        const requestBody = {
            filters: filterMap,
            fieldsRequired: ["FLOOR_LABEL", "ROUTE_CODE", "CART_DATA", "ROUTE_ID"]
        }
        const requestPayload = {
            resourcePath: "svs/floors/data",
            httpMethod: "post",
            processName: "stow",
            requestBody: requestBody
        }
        const response = await getAPIGatewayDataFromParent(requestPayload);
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, SVS_FLOOR_DATA_METRIC, MetricType.SUCCESS);
        } else {
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, SVS_FLOOR_DATA_METRIC, MetricType.FAILED);
        }
        return response;
    } catch (e) {
        Logger.error("Exception in PickNetworkAPI.getFloorData", e);
        logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, SVS_FLOOR_DATA_METRIC, MetricType.FAILED);
    }
    return null;
}

function convertRouteDetailResponse(output, capability, stationConfig, extractedContainers) {
    const model = {
        initialised: true,
        routeInfo: null,
        picklists: [],
        picklistContainers: {},
        containers: [],
        hazmatWeight: output.hazmatWeight,
        bagCount: 0,
        ovCount: 0
    }

    if (extractedContainers != null) {
        model.containers = extractedContainers;
    } else {
        //parse containers
        model.containers = convertContainersToUIModel(output.containers, stationConfig);
    }
    //compute bags/ov counts
    model.containers.forEach(container => {
        model.bagCount += container.bags.length;
        model.ovCount += container.packages.length;
    })

    if(output.route){

        //parse route
        model.routeInfo = getRouteUIModel(output.route, capability, stationConfig);
        model.picklists = model.routeInfo.picklists;
        //var to store Stow Completed Count
        var stowedCount = 0;

        //visibility enabled for stow progress
        const isDynamicRouteContainer = isDynamicRoute(model.routeInfo.algorithm);

        //group containers by picklist
        model.containers.forEach(container => {
            if (model.picklistContainers[container.picklistId]) {
                model.picklistContainers[container.picklistId].push(container);
            } else {
                model.picklistContainers[container.picklistId] = [container];
            }

            container.packages.forEach(stowedPackage => {
                if(stowedPackage.stowed) {
                    stowedCount +=1
                }

            });

            //enrich staging location and routeSequenceNumber for each container
            const cartInfo = model.routeInfo.carts.find(cart => cart.cartId === container.name);
            if (stationConfig && stationConfig.routeDetailsTabViewEnabled) {
                const picklists = (model && model.routeInfo && model.routeInfo.picklists) ? model.routeInfo.picklists : [];
                const cartInfoForPicklist = picklists.flatMap(picklist => picklist.carts || [])
                    .find(cart => cart.cartId === container.name);
                container.stagingLocation = cartInfoForPicklist ? cartInfoForPicklist.stagingLocation : "...";
            } else {
                container.stagingLocation = cartInfo ? cartInfo.stagingLocation : "...";
            }
            container.routeSequenceNumber = cartInfo ? cartInfo.routeSequenceNumber : 1;
            container.dwellDuration = cartInfo ? cartInfo.dwellDuration: 0;
            container.stageTime = cartInfo ? cartInfo.stageTime: null;

            //visibility for stow progress
            container.isDynamicRouteContainer = isDynamicRouteContainer;
        });
        model.routeInfo.stowProgress = getStowProgress(stowedCount , output.route.stowProgress.totalCount)
    }

    return model;
}

function convertContainersToUIModel(inputList, stationConfig){
    const outputList = [];
    inputList.forEach(container => {
        const parentLabel = container.parentResourceLabel ? container.parentResourceLabel : NOT_IN_CART;
        const stageAssociate = container.parentAssignee ? formatAlias(container.parentAssignee) : "...";
        const index = outputList.findIndex(item => item.name === parentLabel && (!container.picklistId || container.picklistId === item.picklistId));
        const containerDetails = getContainer(container);
        if (index !== -1) {
            //if found
            if (container.containerType === CONTAINER_TYPE.PACKAGE) {
                outputList[index].packages.push(containerDetails)
            } else {
                outputList[index].bags.push(containerDetails)
            }
            outputList[index].sequenceNumber = Math.min(outputList[index].sequenceNumber, container.sequenceNumber)
        } else {
            //if not found
            outputList.push({
                name: parentLabel,
                stageAssociate: stageAssociate,
                packages: (container.containerType === CONTAINER_TYPE.PACKAGE) ? [containerDetails] : [],
                bags: (container.containerType !== CONTAINER_TYPE.PACKAGE) ? [containerDetails] : [],
                sequenceNumber: container.sequenceNumber,
                picklistId: container.picklistId ? container.picklistId : "..."
            })
        }
    })

    //sort bags and ovs inside each cart
    outputList.forEach(container => {
        sortObjectsBySequenceNumber(container.bags)
        sortObjectsBySequenceNumber(container.packages)
    });

    //sort carts
    sortObjectsBySequenceNumber(outputList);

    return outputList;
}

function getContainer(container) {
    return {
        label: container.label,
        location: container.stackingLocation,
        picked: container.containerStates.includes("PICKED"),
        pickedV2: container.containerStates.includes("PICKED_V2"),
        staged: container.containerStates.includes("STAGED"),
        departed: container.containerStates.includes("DEPARTED"),
        stowed: container.containerStates.includes("STOWED"),
        sequenceNumber: container.sequenceNumber
    }
}

/** Prioritize Route By Offset **/
export function prioritizeRoute(data) {
     requestPrioritizeRoute(data);
}


async function requestPrioritizeRoute(data) {
    const startTime = Date.now();
    const {dispatcher, routeId, position, stationCode, baseUrl, alertDispatch, stationConfig} = data;
    try {
        const username = await getuserDetails();
        const requestBody = {
            "stationCode": stationCode,
            "operationType": "PRIORITIZE_ROUTE",
            "requestAttributes" : {
                "routeId": [routeId],
                "position": [position],
                "prioritizeStrategy": ["MOVE_TO_POSITION"]
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if (response && response.status === 200) {
            Logger.info( routeId + " Prioritized for  : " + stationCode + " by user : " + username + " to position" + position);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_PRIORITIZE_ROUTE_METRIC, MetricType.SUCCESS);
            alertDispatch({
                type: "SHOW_NOTIFICATION", data: {
                    alert: {title: "Route Prioritized", type: "success"}
                }
            });
            dispatcher({
                type: 'UPDATE_PRIORITIZED_ROUTES',
                data: {
                    prioritizedRoutes: response.data.prioritizedRoutes,
                    stationConfig: stationConfig
                }
            });
        } else {
            var error = {
                response: response
            }
            Logger.error("Exception in PickNetworkAPI.requestPrioritizeRoute" , error);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_PRIORITIZE_ROUTE_METRIC, MetricType.FAILED, error);
            alertDispatch({
                type: "SHOW_NOTIFICATION", data: {
                    alert: {title: "Route Prioritization Failed", type: "error"}
                }
            });
            clearCache(ROUTE_DATA_CACHE_KEY);
        }

    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.requestPrioritizeRoute", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_PRIORITIZE_ROUTE_METRIC, MetricType.FAILED, error);
        alertDispatch({
            type: "SHOW_NOTIFICATION", data: {
                alert: {title: "Route Prioritization Failed", type: "error"}
            }
        });
        clearCache(ROUTE_DATA_CACHE_KEY);
    }
}

/** Prioritize Route : Move To Top **/
export function prioritizeRouteMoveToTopStrategy(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig) {
    requestPrioritizeRouteMoveToTopStrategy(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig);
}

async function requestPrioritizeRouteMoveToTopStrategy(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig) {
    const startTime = Date.now();
    try {
        const username = await getuserDetails();
        const requestBody = {
            "stationCode": stationCode,
            "operationType": "PRIORITIZE_ROUTE",
            "requestAttributes" : {
                "routeId": [routeId],
                "prioritizeStrategy" : ["MOVE_TO_TOP"]
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if (response && response.status === 200) {
            Logger.info( "Prioritized " + routeId + " move to Top Strategy for station" + stationCode + " by user : " + username);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_PRIORITIZE_ROUTE_METRIC, MetricType.SUCCESS);
            alertDispatch({
                type: "SHOW_NOTIFICATION", data: {
                    alert: {title: "Route Prioritized", type: "success"}
                }
            });
        } else {
            var error = {
                response: response
            }
            Logger.error("Exception in PickNetworkAPI.requestPrioritizeRouteMoveToTopStrategy" , error);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_PRIORITIZE_ROUTE_METRIC, MetricType.FAILED, error);
            alertDispatch({
                type: "SHOW_NOTIFICATION", data: {
                    alert: {title: "Route Prioritization Failed", type: "error"}
                }
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.requestPrioritizeRouteMoveToTopStrategy", error);
        logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_PRIORITIZE_ROUTE_METRIC, MetricType.FAILED, error);
        alertDispatch({
            type: "SHOW_NOTIFICATION", data: {
                alert: {title: "Route Prioritization Failed", type: "error"}
            }
        });
    }
}

/** Sideline Route **/
export function sideLineRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig, metricKey) {
    requestSideLineRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig, metricKey);
}

async function requestSideLineRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig, metricKey) {
    const startTime = Date.now();
    try {
        const username = await getuserDetails();
        const requestBody = {
            "stationCode": stationCode,
            "operationType": "SIDELINE",
            "requestAttributes" : {
                "routeId": [routeId]
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if (response && response.status === 200) {
            Logger.info( "Sideline " + routeId + " for station" + stationCode + " by user : " + username);
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_SIDELINE_ROUTE_METRIC, MetricType.SUCCESS);
            alertDispatch({
                type: "SHOW_NOTIFICATION", data: {
                    alert: {title: "Route Sidelined", type: "success"}
                }
            });
        } else {
            var error = {
                response: response
            }
            Logger.error("Exception in PickNetworkAPI.requestSideLineRoute" , error);
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_SIDELINE_ROUTE_METRIC, MetricType.FAILED, error);
            alertDispatch({
                type: "SHOW_NOTIFICATION", data: {
                    alert: {title: "Route Sidelined Failed", type: "error"}
                }
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.requestSideLineRoute", error);
        logOperationalMetric(startTime, stationCode, metricKey, RSWS_SIDELINE_ROUTE_METRIC, MetricType.FAILED, error);
        alertDispatch({
            type: "SHOW_NOTIFICATION", data: {
                alert: {title: "Route Sidelined Failed", type: "error"}
            }
        });
    }
    dispatcher({
        type: "HIDE_LOADER"
    });

}

/** Unassign Associate **/
export function unassignAssociate(args) {
    requestUnassignAssociate(args);
}

async function requestUnassignAssociate(args) {
    const startTime = Date.now();
    const {dispatcher, baseUrl, alertDispatch, filterDispatcher, xptNodes, capability, stationConfig, unassignParams} = args;
    let {stationCode, picklistId, associateId} = args;
    try {
        const username = await getuserDetails();
        //For handling the case when sometimes backend does not sends domain for alias
        associateId = (associateId && associateId.includes("@amazon")) ? associateId : associateId + "@amazon.com";

        //TODO: Change operation and attributes to UNASSIGN_PICKER after backend fix for associate id.
        let requestBody = {
            "stationCode": stationCode,
            "operationType": "UNASSIGN_STAGER",
            "requestAttributes" : {
                "stagelistId": [picklistId],
                "associateId": [associateId]
            }
        }

        /** This check is to call different executors for unassign operations. Based on the unassignParams, we identify
         * whether to call UNASSIGN_STAGER or UNASSIGN_PICKER operations with necessary requestAttributes. These attributes
         * are passed through RSWS to further backend services SPS and SES.**/
        if (stationConfig && stationConfig.unassignPickerEnabled && unassignParams) {
            requestBody = {
                "stationCode": stationCode,
                "operationType": unassignParams.operationType,
                "requestAttributes" : {
                    "picklistId": [unassignParams.picklistId],
                    "routeId": [unassignParams.routeId],
                    "associateId": [associateId]
                }
            }
        }

        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if (response && response.status === 200) {
            Logger.info( "Unassign Associate for picklist ID : " + picklistId + "for associateID" + associateId + " for station" + stationCode + " by user : " + username);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_UNASSIGN_ROUTE_METRIC, MetricType.SUCCESS);
            clearCache(ROUTE_DATA_CACHE_KEY);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {alert: {title: "Associate successfully unassigned", type: "success"}}
            });
            dispatcher({
                type: 'REFRESH_VIEW',
                data: {
                    dispatcher: dispatcher,
                    filterDispatcher: filterDispatcher,
                    baseUrl: baseUrl,
                    capability: capability,
                    xptNodes: xptNodes,
                    stationConfig: stationConfig
                }
            });
        } else {
            var error = {
                response: response
            }
            Logger.error("Exception in PickNetworkAPI.requestUnassignAssociate" + response.status);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_UNASSIGN_ROUTE_METRIC, MetricType.FAILED, error);
            clearCache(ROUTE_DATA_CACHE_KEY);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {alert: {title: "Associate could not be unassigned", type: "error"}}
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.requestUnassignAssociate", error);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_UNASSIGN_ROUTE_METRIC, MetricType.FAILED, error);
        clearCache(ROUTE_DATA_CACHE_KEY);
        alertDispatch({
            type: "SHOW_NOTIFICATION",
            data: {alert: {title: "Associate could not be unassigned", type: "error"}}
        });
    }
    dispatcher({
        type: "HIDE_LOADER"
    });

}

/** Cut Route **/
export function cutRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig) {
    requestCutRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig);
}

/** Cut Route **/
export function forceAssign(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig) {
    requestForceAssign(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig);
}

async function requestCutRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig) {
    const startTime = Date.now();
    try {
        const username = await getuserDetails();
        const requestBody = {
            "stationCode": stationCode,
            "operationType": "CUT_ROUTE",
            "requestAttributes": {
                "routeId": [routeId]
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_CUT_ROUTE_METRIC, MetricType.SUCCESS);
            Logger.info( "CutRoute : " + routeId + " for station" + stationCode + " by user : " + username);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {
                    alert: {title: "Route cut successfully", type: "success"}
                }
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in PickNetworkAPI.requestCutRoute" , error);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_CUT_ROUTE_METRIC, MetricType.FAILED, error);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {
                    alert: {title: "Route cut failed", type: "error"}
                }
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.requestCutRoute", error);
        logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_CUT_ROUTE_METRIC, MetricType.FAILED);
        alertDispatch({
            type: "SHOW_NOTIFICATION",
            data: {
                alert: {title: "Route cut failed", type: "error"}
            }
        });
    }
}

async function requestForceAssign(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig) {
    const startTime = Date.now();
    try {
        const username = await getuserDetails();
        const requestBody = {
            "stationCode": stationCode,
            "operationType": "FORCE_ASSIGN",
            "requestAttributes": {
                "routeId": [routeId]
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
           response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if (response && response.status === 200) {
            Logger.info( "ForceAssign : " + routeId + " for station" + stationCode + " by user : " + username);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_FORCE_ASSIGN_ROUTE_METRIC, MetricType.SUCCESS);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {
                    alert: {title: "Force assign successful", type: "success"}
                }
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in PickNetworkAPI.requestCutRoute" , error);
            logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_FORCE_ASSIGN_ROUTE_METRIC, MetricType.FAILED, error);
            alertDispatch({
                type: "SHOW_NOTIFICATION",
                data: {
                    alert: {title: "Force Assign failed. Please try again.", type: "error"}
                }
            });
        }
    } catch (error) {
        Logger.error("Exception in PickNetworkAPI.requestForceAssign", error);
        logOperationalMetric(startTime, stationCode, ROUTE_INFO_METRIC_KEY, RSWS_FORCE_ASSIGN_ROUTE_METRIC, MetricType.FAILED, error);
        alertDispatch({
            type: "SHOW_NOTIFICATION",
            data: {
                alert: {title: "Force Assign failed. Please try again.", type: "error"}
            }
        });
    }
    dispatcher({
        type: "HIDE_LOADER"
    });
}

function formatPickAssociates(pickAssociates) {
    if (Array.isArray(pickAssociates) && pickAssociates.length > 0) {
        return pickAssociates.map(associate => {
            associate.fullAlias = associate.alias;
            associate.alias = formatAlias(associate.alias);
            return associate;
        });
    }
    return [];
}

function getUniquePickerAlias(pickAssociates) {
    if (Array.isArray(pickAssociates) && pickAssociates.length > 0) {
        const allAlias = pickAssociates.map(associate => formatAlias(associate.alias));
        return allAlias.filter(function (item, pos) {
            return allAlias.indexOf(item) === pos;
        });
    }
    return [];
}

function getStationPairs(route) {
    if (route.sourceLocation != null && route.sourceLocation.length > 0) {
        return route.sourceLocation.filter(function (item, pos) {
            return route.sourceLocation.indexOf(item) === pos;
        }).join(", ");
    }
    return "...";
}

function getAisles(route) {
    if (Array.isArray(route.sourceLocation) && route.sourceLocation.length > 0) {
        return route.sourceLocation.filter(function (item, pos) {
            return route.sourceLocation.indexOf(item) === pos;
        });
    }
    return [];
}

/**
 * Extracts unique assigned work groups from a route's picklists.
 *
 * @param {Object} route - The route object containing picklists.
 * @returns {Array} - A list of unique assigned work groups.
 */
function getAssignedWorkGroupsForRoute(route) {
    if (!route || !route.picklists || !route.picklists.length) {
        return [];
    }

    const workGroups = route.picklists
        .map(picklist => picklist.assignedWorkGroupLabel)
        .filter(wgLabel => wgLabel && wgLabel.trim() !== '');

    return Array.from(new Set(workGroups));
}

/**
 * Extracts unique next work groups from a route's picklists.
 *
 * @param {Array} picklists - The picklists array.
 * @returns {Array} - A list of unique next work groups.
 */
function getNextWorkGroupsForRoute(picklists) {
    if (!picklists || !picklists.length) {
        return [];
    }

    const workGroups = picklists.flatMap((picklist) => {
        if (!picklist || !picklist.nextWorkGroups || !Array.isArray(picklist.nextWorkGroups)) {
            return [];
        }
        return picklist.nextWorkGroups;
    });

    return Array.from(new Set(workGroups));
}

/** Get Station Config **/
export function fetchNodeConfig(dispatcher, baseUrl, metricKey) {
    getNodeConfig(dispatcher, baseUrl, metricKey);
}

async function getNodeConfig(dispatcher, baseUrl, metricKey) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        let response;
        if (await isRSWSBosonFlowEnabled()) {
            const requestPayload = {
                resourcePath: "/apigw/config",
                requestParams: {stationCode: [stationCode]},
                httpMethod: "get",
                processName: "routeStaging"
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            const api = axios.create({
                baseURL: baseUrl,
                timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
            });
            response = await api.get("/rsws/config?stationCode=" + stationCode);
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_STATION_CONFIG_METRIC, MetricType.SUCCESS);
            const stationConfig = response.data;
            dispatcher({
                type: "RECEIVE_STATION_CONFIG",
                data: {
                    stationConfig: {
                        initialised: true,
                        ...stationConfig,
                        // Temporary hot-fix to use an old configuration which was not in use.
                        atRiskMetricV2: stationConfig.parallelPickEnabled && stationConfig.manageEnabled,
                        refreshInterval: stationConfig.routeRefreshRate
                    }
                }
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Response for getNodeConfig : " , error);
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_STATION_CONFIG_METRIC, MetricType.FAILED, error);
        }
    } catch (e) {
        Logger.error("Exception in PickNetworkAPI.getNodeConfig", e);
        logOperationalMetric(startTime, stationCode, metricKey, RSWS_STATION_CONFIG_METRIC, MetricType.FAILED, e);
    }
    return null;
}

/** Get XPT Stations **/
export function fetchSubStations(dispatcher, baseUrl, capability, stationConfig) {
    if (DEFAULT_CAPABILITIES.includes(capability)) {
        getSubStationsWithParentNode(dispatcher, baseUrl, stationConfig);
    }
}

async function getSubStationsWithParentNode(dispatcher, baseUrl, stationConfig) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/details/station/" + stationCode,
                httpMethod: "get",
                processName: "routeStaging"
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get("/rsws/details/station/" + stationCode);
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_STATION_DETAILS_METRIC, MetricType.SUCCESS);
            const subStationsResponse = response.data;
            const xptNodeList = parseSubStationsResponse(subStationsResponse);
            if (xptNodeList && Array.isArray(xptNodeList) && xptNodeList.length > 0) {
                xptNodeList.push(stationCode);
            }
            dispatcher({
                type: "RECEIVE_XPT_NODES", data: {xptNodes: xptNodeList}
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in PickNetworkAPI.getSubStations" , error);
            logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_STATION_DETAILS_METRIC, MetricType.FAILED, error);
        }
    } catch (e) {
        Logger.error("Exception in PickNetworkAPI.getSubStations", e);
        logOperationalMetric(startTime, stationCode, PICK_TAB_METRIC_KEY, RSWS_STATION_DETAILS_METRIC, MetricType.FAILED, e);
    }
    return null;
}

function parseSubStationsResponse(response) {
    if (response && Array.isArray(response.subNodes)) {
        return response.subNodes.map(station => {
            return station.code;
        }, []);
    }
    return [];
}



export async function getUserEmployeeTCPRolesUsingUserId(tcpRoles) {
    const response = await getTcpRolesFromParent();
    return parseGetEmployeeDetailsFromTCPResponseList(JSON.parse(response.roles), tcpRoles);

}

export function parseGetEmployeeDetailsFromTCPResponseList(responseData, validTcpRoles) {

    if (validTcpRoles && !validTcpRoles.some( role => responseData.includes(role))) {
        throw new Error("Employee Validation Failed");

    }

}

/** Update routes from list **/
export function updatePrioritizedRoutes(prioritizedRoutes, routeList, stationConfig) {
    //update pickPriority
    prioritizedRoutes.forEach(prioritizedRoute => {
        routeList.find((route, index) => {
            if (route.routeId === prioritizedRoute.routeId) {
                routeList[index] = {
                    ...route,
                    pickPriority: prioritizedRoute.priority
                }
                return true;
            }
            return false;
        });
    });

    //Sort and update priority.
    return enrichDisplayPriority(routeList, stationConfig);
}





// WEBPACK FOOTER //
// ./src/components/pickStatus/network/PickNetworkAPI.js